module.exports = __webpack_public_path__ + "static/reactnative-2149cd237b8a94c021375b5c0f3853a5.png";